// extracted by mini-css-extract-plugin
export default {"eventsBox":"events_eventsBox__C3dfY","rowBox":"events_rowBox__M2E0f","resetBox":"events_resetBox__AeE3K"};